// Enhance product media to open the theme's ProductModal when clicking the image
function initLightbox() {
    // Use delegated handler: clicking the media image should open the modal via the internal button
    document.addEventListener('click', (event) => {
        // Ignore clicks that are already on a button (let ModalOpener handle it)
        if (event.target.closest('button')) return;

        // Find the nearest modal-opener ancestor
        const opener = event.target.closest('.product__modal-opener, modal-opener');
        if (!opener) return;

        // Find the button - could be within the opener or as a sibling in the parent modal-opener
        let button = opener.querySelector('button');
        if (!button && opener.classList.contains('product__modal-opener')) {
            // If the opener is the image itself, find the parent modal-opener and get the button from there
            const parentModalOpener = opener.closest('modal-opener');
            if (parentModalOpener) {
                button = parentModalOpener.querySelector('button');
            }
        }
        if (!button) return;

        // If the click was on an element that should not open the modal, skip
        if (event.target.closest('.deferred-media, video, model-viewer, iframe')) return;

        // Trigger the internal button to open the ProductModal
        try {
            console.debug('[lightbox] click -> button found, triggering click', { target: event.target, button });
            button.click();
        } catch (e) {
            console.warn('[lightbox] button.click() threw, dispatching event', e);
            const evt = new MouseEvent('click', { bubbles: true, cancelable: true });
            button.dispatchEvent(evt);
        }

        // Fallback: if modal element exists but didn't open, call its show() method
        const parentModalOpener = opener.closest('modal-opener') || (opener.tagName === 'MODAL-OPENER' ? opener : null);
        const modalSelector = parentModalOpener ? (parentModalOpener.getAttribute('data-modal') || parentModalOpener.dataset.modal) : null;
        if (modalSelector) {
            const modalEl = document.querySelector(modalSelector);
            if (modalEl) {
                // If modal didn't open shortly after clicking, call show() directly
                setTimeout(() => {
                    const isOpen = modalEl.hasAttribute && modalEl.hasAttribute('open');
                    if (!isOpen) {
                        try {
                            console.debug('[lightbox] fallback: calling modal.show() directly', { modalSelector, modalEl });
                            if (typeof modalEl.show === 'function') modalEl.show(button);
                        } catch (err) {
                            console.error('[lightbox] failed to call modal.show()', err);
                        }
                    }
                }, 50);
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', initLightbox);
